
import { UpdateItemModel } from '@onArte/shared/models/website/items';

export class CreateItemModel extends UpdateItemModel {}
